export default __webpack_public_path__ + "static/media/subject.9649e424.jpeg";